<template>
  <AppSection id="clients" :title="$getConst.pages.client.list_of_client" type="page">
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.client.list_of_client)"
      type="section"
      :button="hasPermission($getConst.permissions.createClient)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      @onClick="openClientModal"
    >

      <AppDataTable
        ref="clientsTable"
        :fields="fields"
        :actions="actions"
        end-point="clients"
        @onDelete="confirmDelete"
        @onEdit="edit"
      >
        <template v-slot:status="item">
          <template v-if="hasPermission($getConst.permissions.setStatusClient) ">
            <b-spinner v-if="enablingClientId == item.row.id" small type="grow" label="Spinning"></b-spinner>
            <template v-else>
              <b-button class="border-0" size="sm" variant="outline-success" v-if="item.data"
                        @click="enableOrDisableClient(item.row.id)">
                <i :class="$getConst.icons.power_off"></i>
              </b-button>
              <b-button class="border-0" size="sm" variant="outline-danger" v-else
                        @click="enableOrDisableClient(item.row.id)">
                <i :class="$getConst.icons.power_off"></i>
              </b-button>
            </template>
          </template>
          <template v-else>
            <span class="text-success" v-if="item.data">{{$t($getConst.pages.pageUsers.enabled) | capitalize}}</span>
            <span class="text-danger" v-else>{{$t($getConst.pages.pageUsers.disabled) | capitalize}}</span>
          </template>
        </template>
      </AppDataTable>
      <ClientModal :id="clientAddModal"/>
      <ClientModal :id="clientEditModal" :client-to-edit="clientToEdit"/>
      <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="cancelDelete"
        @onConfirm="deleteClient"/>
    </AppSection>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../components/common/table/AppDataTable";
  import {deleteClient,enableOrDisableClient} from "../../api/clients.api";
  import ClientModal from "./ClientModal";
  import AppSection from "../../components/common/sections/AppSection";
  import AppConfirmationModal from "../../components/common/modals/AppConfirmationModal";
  export default {
    name: "index",
    components: {AppSection, AppConfirmationModal, ClientModal, AppDataTable},
    data() {
      return {
        clientToDelete: null,
        clientToEdit:null,
        clientAddModal: 'client-add-modal',
        clientEditModal: 'client-edit-modal',
        fields: [
          {key: 'id', label:'ID', sortable: true, filterable: true},
          {key: 'name', label:'client name', sortable: true, filterable: true},
          {key: 'scope.name', label: 'Scope', sortable: false, filterable: true},
          {key: 'status', label:'status', sortable: true, filterable: true},
        ],
        actions: [
          {action: 'onEdit', variant: 'outline-secondary', icon: this.$getConst.icons.edit, permissions: [this.$getConst.permissions.updateClient]},
          {action: 'onDelete', variant: 'outline-danger', icon: this.$getConst.icons.delete, permissions: [this.$getConst.permissions.deleteClient]},
        ],
        enablingClientId: '',
        scopes: [],
      }
    },
    created() {
      this.scopes = this.$store.getters['auth/allScopes'];
      this.fields[3].filterable = [
        { value: '1', text: this.$t(this.$getConst.pages.pageUsers.enabled) },
        { value: '0', text: this.$t(this.$getConst.pages.pageUsers.disabled) }
      ];

      this.fields[2].filterable = this.scopes.map(scope => {
        return {value: scope.name, text: scope.name};
      });
    },
    mounted() {
      this.$root.$on('onAddClient', client => {
        client.status = true
        this.onAddClient(client);
      });
      this.$root.$on('onEditClient', client => {
        this.onEditClient(client);
      });
    },
    methods: {
      confirmDelete(client) {
        this.clientToDelete = client;
        this.$bvModal.show('confirmation-modal')
      },
      cancelDelete() {
        this.clientToDelete = null;
      },
      deleteClient() {
        deleteClient(this.clientToDelete.id).then(
          () => {
            this.$refs.clientsTable.removeItem(this.clientToDelete);
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.client.client_deleted));
          },
          (error) => {
            if (error.response.status == '422') {
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.err_client_used_in_timesheet_or_invoice));
            }else {
              this.handleApiError(error);
            }
            this.$refs.confirmDelete.close();
          }
        )
      },

      onAddClient(client) {
        this.$snotify.success(this.$t(this.$getConst.pages.client.client_added));
        this.$refs.clientsTable.addItem(client);
      },
      edit(client) {
        this.clientToEdit = Object.assign({}, client);
        this.openClientEditModal();
      },
      onEditClient(client) {
        this.$snotify.success(this.$t(this.$getConst.pages.client.client_updated));
        this.$refs.clientsTable.editItem(client);
      },
      openClientModal() {
        this.$bvModal.show(this.clientAddModal);
      },
      openClientEditModal() {
        this.$bvModal.show(this.clientEditModal);
      },
      enableOrDisableClient(clientId) {
        this.enablingClientId = clientId;
        enableOrDisableClient(clientId).then(
          response => {
            this.$snotify.success(this.$t(this.$getConst.pages.client.client_updated));
            this.$refs.clientsTable.editItem(response.data);
            this.enablingClientId = '';
          },
          error => {
            this.enablingClientId = '';
            this.handleApiError(error);
          }
        );
      },
    },
    beforeDestroy() {
      this.$root.$off('onAddClient');
      this.$root.$off('onEditClient');
    }
  }
</script>

<style >
  .badge {
    height: inherit;
    width: 80%;
  }
</style>
